$(document).ready(function () {
  AOS.init();
  const html = document.documentElement;

  $('#ContactForm').submit(function (e) {
    e.preventDefault();

    var formData = $(this).serialize();

    $.ajax({
      url: 'send_email.php',
      type: 'POST',
      data: formData,
      dataType: 'json',
      beforeSend: function () {
        toastr.info("Senden...", "Bitte warten");
      },
      success: function (response) {
        if (response.status === "success") {
          window.location.href = "thankyou.html";
        } else {
          toastr.error(response.message);
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.error("AJAX Fehler: ", textStatus, errorThrown);
        console.log("Antwort: ", jqXHR.responseText);
        toastr.error("Es gab einen unerwarteten Fehler beim Senden.");
      }
    });
  });



  if (document.getElementById('calendly-inline-widget')) {
    Calendly.initInlineWidget({
      url: 'https://calendly.com/frederik-pfeiffer-stopfa/kostenlose-erstberatung',
      parentElement: document.getElementById('calendly-inline-widget'),
      prefill: {},
      utm: {}
    });
  }
});
